<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Academic Calender</h1>
      <ul>
        <li>
          <a class="active" [routerLink]="['/']">Home</a>
        </li>
        <li>
          <a>Academics</a>
        </li>
        <li>Academic Calender</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 discipline-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <academics-menu></academics-menu>
        </div>

        <div class="col-lg-8">
          <div class="discipline-content-wrap">
            <h2 class="discipline-title">Academic Calender</h2>


          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

